import { ArrowUpRight } from "lucide-react";
import { SectionHead, FadeIn, scrollToId } from "./Shared";

const SERVICES = [
  {
    num: "01",
    title: "Automotive Portraits & Stills",
    desc: "Static car portraits, curated locations, detail captures. Sharp, high-value images that make the machine the hero.",
  },
  {
    num: "02",
    title: "Vehicle Rollers & Dynamic Reels",
    desc: "Rolling footage and motion passes that carry real speed — engineered for polish, built for social.",
  },
  {
    num: "03",
    title: "Event & Banquet Cinematics",
    desc: "Galas, banquets and private events covered with cinematic coverage and dynamic highlight recaps.",
  },
  {
    num: "04",
    title: "Business & Brand Intro Videos",
    desc: "Owner stories and showcase promos that give GTA businesses a film-grade first impression.",
  },
];

export default function Services() {
  return (
    <section id="services" className="relative py-16 md:py-24" data-testid="services-section">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <SectionHead index="03" kicker="Services" title="What I" accent="Shoot" />
        <div className="grid grid-cols-1 md:grid-cols-2 border-t border-l border-white/10">
          {SERVICES.map((s, i) => (
            <FadeIn key={s.num} delay={i * 0.05}>
              <button
                data-testid={`service-card-${s.num}`}
                onClick={() => scrollToId("#booking")}
                className="group w-full text-left h-full border-b border-r border-white/10 p-8 md:p-12 bg-surface/30 hover:bg-card2 hover:shadow-[inset_0_0_0_1px_rgba(229,169,60,0.35)] transition-all duration-300"
              >
                <div className="flex items-start justify-between mb-8">
                  <span className="font-mono text-xs tracking-[0.3em] text-gold">/{s.num}</span>
                  <ArrowUpRight size={20} className="text-zinc-600 group-hover:text-gold group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" />
                </div>
                <h3 className="font-display text-xl md:text-2xl font-bold uppercase tracking-tight text-zinc-100 mb-4 group-hover:text-gold transition-colors duration-300">
                  {s.title}
                </h3>
                <p className="text-sm text-zinc-400 leading-relaxed max-w-md">{s.desc}</p>
              </button>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
